//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});

const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);

const href=$(location).attr('href');
let host=	$(location).attr('hostname');
const ref=document.referrer;
const hash=$(location).attr('hash');

if(href.indexOf("/test/")>0)	{
	host=host + "/test";
}

$(document).ready(function(){
	
  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'swing');//fast
        return false;
      }
    }
  });
  
  //Menu
  $("#menu-btn").on("click",function(){
	  $("#menu").toggleClass("open");
  });
  
  //exValidation
	if($(".validationform").length){
		/*エラー吹き出し表示*/
		const validation = $(".validationform").exValidation({
		  stepValidation: true,
		  errHoverHide:true,
		  errTipCloseBtn:false,
		  scrollAdjust:0,
		  errMsgPrefix : ""
		});
	}
	
	
  $(".open-modal").on("click",function(){
		var modalName= $(this).data("modalname");
		$("." + modalName).addClass("modal-open");
  });

  $(".close-modal").on("click",function(){
	  var modalName= $(this).data("modalname");
	 $("." + modalName).removeClass("modal-open");
  });
  
  
	
	
	
	
	//誕生日初期値 1970/1/1
	if($(".birth-year").length){
		$(".birth-year").on("focus",function(){
			if($(this).val()==""){
				$(this).val("1970");
			}
		});
	}
	
	//購入年月初期値 2016/1/1
	if($(".buy-year").length){
		$(".buy-year").on("focus",function(){
			if($(this).val()==""){
				$(this).val("2016");
			}
		});
	}
	
	//パスワード表示
	if($(".view-password").length){
		$(".view-password").on("click",function(){
			if($(this).text() == "表示"){
				$("#fpassword").attr("type","text");
				$(this).text("非表示");
			}else{
				$("#fpassword").attr("type","password");
				$(this).text("表示");
			}
		})
	}
	
	//製品名の選択
	if($(".product-name").length){
		var productNumber;
		$(".product-name").on("focus",function(){
			productNumber=$(this).data("productnum");
			$(".register-product-list").insertAfter("#fproduct"+ productNumber + "-name").addClass("is-show").attr("data-productnum",productNumber);
		});
		$(document).click(function(event) {
	  	if(!$(event.target).closest('.register-product-list.is-show').length && !$(event.target).closest('.product-name').length) {
	    	//console.log('外側がクリックされました。');
	    	// 製品選択モーダルを閉じる
			closeProductSelector();
	  	} else {
	    	//console.log('内側がクリックされました。');
	  	}
		});
		$(".register-product-list li").on("click",function(){
			var product = $(this).data("productname");
			var productNo = $(this).data("productno");

			$("#fproduct" + productNumber + "-name").val(product).change();
			$("#fproduct" + productNumber + "-no").val(productNo);
			// 製品選択モーダルを閉じる
			closeProductSelector();
		});
	}
	
	//製品の拡大画像
	
		$(".register-product-list li").each(function(){
			let vp = $(window).width();
			if(vp > 959){
				// tab以上のサイズは拡大画像を出す
				if($(this).data("productno") != 999){
					if($(".register-product-thumb").length){
						$(".register-product-thumb > img",this).on({
							"mouseenter":function(){
								var imgurl = $(this).attr("src").replace("thumb","img");
								var html='<div class="register-product-image"><img src="' + imgurl + '"></div>';
								$(this).parents(".register-product-thumb").append(html);
								//console.log(imgurl);
							},
							"mouseleave":function(){
								$(".register-product-image").remove();
							}
						});
					}
				}
			}else{
				// 拡大画像を出さない
			}
		});
		
	
	//よくあるご質問
	if($(".faq-q").length){
		$(".faq-q").on("click",function(){
			$(this).siblings(".faq-a").slideToggle();
			$(this).toggleClass("faq-open");
		});
	}

	// アコーディオン要素が存在する場合のみ実行
	if (document.querySelectorAll('.accordion-header').length > 0 || document.querySelectorAll('.sub-accordion-header').length > 0) {
        // メインアコーディオンの処理
        const accordionHeaders = document.querySelectorAll('.accordion-header:not(.direct-select)');
        accordionHeaders.forEach(header => {
            header.addEventListener('click', function() {
                this.classList.toggle('active');
                const content = this.nextElementSibling;

                if (content.style.display === 'block') {
                    // アコーディオンを閉じる前に、内部の全てのサブアコーディオンを閉じる
                    const nestedAccordions = content.querySelectorAll('.sub-accordion-header.active');
                    nestedAccordions.forEach(nestedHeader => {
                        // サブアコーディオンのactiveクラスを削除
                        nestedHeader.classList.remove('active');
                        // サブアコーディオンのコンテンツを非表示
                        const nestedContent = nestedHeader.nextElementSibling;
                        if (nestedContent) {
                            nestedContent.style.display = 'none';
                        }
                    });                   
                    // 最後にメインアコーディオンを閉じる
                    content.style.display = 'none';
                } else {
                    content.style.display = 'block';
                }
            });
        });
        
        // サブアコーディオンの処理
        const subAccordionHeaders = document.querySelectorAll('.sub-accordion-header');
        subAccordionHeaders.forEach(header => {
            header.addEventListener('click', function() {
                this.classList.toggle('active');
                const content = this.nextElementSibling;
                if (content.style.display === 'block') {
                    // サブアコーディオンを閉じる
                    content.style.display = 'none';
                } else {
                    content.style.display = 'block';
                }
            });
        });
    }
	
});
// アコーディオン要素をすべて閉じる関数
function closeAllAccordions() {
    // すべてのアコーディオン（メインとサブ）を選択
    const allAccordions = document.querySelectorAll('.accordion-header.active, .sub-accordion-header.active');
    
    // 各アコーディオンを閉じる
    allAccordions.forEach(header => {
        header.classList.remove('active');
        const content = header.nextElementSibling;
        if (content && content.style.display === 'block') {
            content.style.display = 'none';
        }
    });
}
// 製品選択モーダルを閉じる
function closeProductSelector() {
    $(".register-product-list").removeClass("is-show");
    
    // アコーディオン要素をすべて閉じる
    closeAllAccordions();
}

function deviceFunc(w){
	const bp = [559,959,1280];
	if(w > bp[1]){ //タブレット以上（PC）

  }else{ //タブレット以下
	
  }
  if (w > bp[0]){//スマートフォン以上
	  $(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  }else{ //スマートフォン以下
	 	$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});	
  }
}
/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}